import useQuery from './useQuery';

/** M9 (#155–#158): the org's sales channels (5 built-ins + custom rows),
 * ordered, including disabled ones. Any member can read. */
function useChannelsQuery(sellerId, params) {
  return useQuery(`/sellers/${sellerId}/channels/`, {
    enabled: Boolean(sellerId),
    staleTime: 60 * 1000,
    ...params,
  });
}

export default useChannelsQuery;
